// Header móvil sobre el Main Banner (guía SS25 pág. 5):
// "El menú comienza sin fondo, en color blanco, para que conviva junto con el
// Main Banner. Conforme se hace scroll, aumenta la opacidad del fondo blanco y
// el contenido se va a negro, hasta pasar el Main Banner."
(() => {
  const header = document.querySelector('.header-wrapper--over-hero-tbl');
  if (!header) return;

  const hero = document.querySelector('#MainContent .banner');
  if (!hero) {
    header.classList.remove('header-wrapper--over-hero-tbl');
    return;
  }

  const mq = window.matchMedia('(max-width: 749px)');
  let ticking = false;

  const setHeights = () => {
    document.documentElement.style.setProperty('--tbl-header-h', `${header.offsetHeight}px`);
  };

  const update = () => {
    ticking = false;
    if (!mq.matches) return;
    // El fondo termina de aparecer bastante antes de que acabe el hero, para que
    // el contenido nunca quede ilegible sobre las zonas claras de la foto.
    const fadeDistance = Math.max(1, hero.offsetHeight * 0.45);
    const progress = Math.min(1, window.scrollY / fadeDistance);
    header.style.setProperty('--tbl-header-alpha', progress.toFixed(3));
    header.classList.toggle('is-solid-tbl', progress > 0.6);
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  const sync = () => {
    setHeights();
    if (mq.matches) {
      update();
    } else {
      header.style.removeProperty('--tbl-header-alpha');
      header.classList.remove('is-solid-tbl');
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', sync);
  mq.addEventListener('change', sync);
  sync();
})();
